<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'organization.detail'">
    @if (showBackButton()) {
      <htx-button variant="tertiary" icon="arrow_back" (click)="backToList()">{{
        'button.back' | transloco
      }}</htx-button>
    }

    <div class="panel">
      <div class="header-section">
        <div class="header-title-section">
          <h1 class="header-title">{{ 'organization.detail.header' | transloco }}</h1>
          <p class="header-subtitle">{{ 'organization.detail.sub-header' | transloco }}</p>
        </div>
        @if (canEditOrganizations) {
          <htx-button
            variant="tertiary"
            icon="edit"
            (click)="edit()"
            [disabled]="isOrganizationPending()"
            >{{ 'button.edit' | transloco }}</htx-button
          >
        }
      </div>

      <htx-data-display
        [title]="t('organisationDetails')"
        [icon]="'business'"
        [data]="(organisationDetails$ | async) ?? []"
      ></htx-data-display>

      <htx-data-container
        [title]="'organization.detail.organizationMembers' | transloco"
        icon="people"
      >
        @if (canAddMembers) {
          <div class="member-table-actions">
            <htx-button
              variant="primary"
              icon="person_add"
              (click)="addMember()"
              [disabled]="isOrganizationPending()"
              >{{ 'button.invite' | transloco }}</htx-button
            >
          </div>
        }
        <htx-table
          [data]="(member$ | async) || []"
          [columns]="(columnConfig$ | async) || []"
        ></htx-table>
      </htx-data-container>
    </div>
  </div>
</app-protected-content>

<ng-template #columnRoles let-row>
  @let member = getTyped(row);
  <div class="role-badges">
    @for (role of member.roles; track role) {
      <htx-badge
        [text]="'organization.member.roles.labels.' + role.toLowerCase() | transloco"
        variant="tertiary"
      ></htx-badge>
    }
  </div>
</ng-template>

<ng-template #columnActions let-row>
  @let member = getTyped(row);
  <div class="action-buttons">
    <htx-button
      variant="tertiary"
      icon="visibility"
      [iconOnly]="true"
      tooltip="Anzeigen"
      (click)="viewMember(member)"
    ></htx-button>
    <htx-button
      variant="tertiary"
      icon="edit"
      [iconOnly]="true"
      tooltip="Bearbeiten"
      [disabled]="isOrganizationPending()"
      (click)="editMember(member)"
    ></htx-button>
  </div>
</ng-template>
